import React from "react";

const TextLoadingSkeleton = () => {
    return <div className="skeleton-loader bg-gray-200 rounded w-1/2" />;
};

export default TextLoadingSkeleton;
